import { useState } from "react";
import { LucideChevronRight, LucideChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ClassCard } from "@/components/entities/ClassCard";

const PAGE_SIZE = 10;

function yearSortKey(year) {
  if (!year) return -1;
  const match = year.match(/\d{4}/);
  return match ? parseInt(match[0]) : -1;
}

function groupByYear(items) {
  const sections = [];
  let currentYear;
  for (const item of items) {
    if (item.schoolYear !== currentYear) {
      currentYear = item.schoolYear;
      sections.push({ year: currentYear, items: [] });
    }
    sections[sections.length - 1].items.push(item);
  }
  return sections;
}

export default function ClassList({ items, getLinkPath, getMenuItems, getOwnerName, getPermission, size = "lg" }) {
  const [page, setPage] = useState(0);

  const sorted = [...items].sort((a, b) => yearSortKey(b.schoolYear) - yearSortKey(a.schoolYear));
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);
  const pageItems = sorted.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  const sections = groupByYear(pageItems);

  return (
    <div className="space-y-5">
      {sections.map(({ year, items: sectionItems }) => (
        <div key={year ?? "__no_year__"} className="space-y-2">
          <div className="flex items-center gap-3">
            <div className="h-0.5 flex-1 bg-border" />
            <span className="text-lg font-bold text-foreground">
              {year ?? "No Year"}
            </span>
            <div className="h-0.5 flex-1 bg-border" />
          </div>
          <div className="flex flex-wrap gap-2">
            {sectionItems.map((item) => (
              <ClassCard
                key={item._id}
                item={item}
                getLinkPath={getLinkPath}
                getMenuItems={getMenuItems}
                ownerName={getOwnerName?.(item)}
                permission={getPermission?.(item)}
                size={size}
              />
            ))}
          </div>
        </div>
      ))}

      {totalPages > 1 && (
        <div className="flex items-center justify-between pt-2">
          <Button variant="outline" size="sm" onClick={() => setPage((p) => p - 1)} disabled={page === 0} className="gap-1">
            <LucideChevronLeft size={14} />
            Prev
          </Button>
          <span className="text-sm text-muted-foreground">
            Page {page + 1} of {totalPages}
          </span>
          <Button variant="outline" size="sm" onClick={() => setPage((p) => p + 1)} disabled={page === totalPages - 1} className="gap-1">
            Next
            <LucideChevronRight size={14} />
          </Button>
        </div>
      )}
    </div>
  );
}
